var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5731_74801",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2 20.5C17.1705 20.5 21.2 16.339 21.2 13.5C21.2 10.661 17.1705 6.5 12.2 6.5C7.22945 6.5 3.19995 10.664 3.19995 13.5C3.19995 16.336 7.22945 20.5 12.2 20.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 16.5C12.9956 16.5 13.7587 16.1839 14.3213 15.6213C14.8839 15.0587 15.2 14.2956 15.2 13.5C15.2 12.7044 14.8839 11.9413 14.3213 11.3787C13.7587 10.8161 12.9956 10.5 12.2 10.5C11.4043 10.5 10.6412 10.8161 10.0786 11.3787C9.51602 11.9413 9.19995 12.7044 9.19995 13.5C9.19995 14.2956 9.51602 15.0587 10.0786 15.6213C10.6412 16.1839 11.4043 16.5 12.2 16.5Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83203 5.633L8.12903 7.443M18.0125 5.855L16.715 7.665M12.2045 3.5V6.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5731_74801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.199951 0H24.2V24H0.199951V0Z",
    fill: "#358888"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMataIcon);
export default __webpack_public_path__ + "static/media/mata_icon.94713cae36ed37f96149334055b80d3a.svg";
export { ForwardRef as ReactComponent };